<template>
    <div class="p-3">
        <div class="px-4 py-3 bg-gray-300 rounded-xl">
            <form method="POST" action="/filterEvent" class="flex justify-between">
                <input type="hidden" name="_token" :value="csrf">
                <div class="mr-1 md:mr-0">
                    <select name="speaker" v-model="speaker" class="w-full px-2 py-2 bg-white border border-gray-300 md:w-40 lg:w-64 xl:w-80 hover:border-gray-400 focus:outline-none focus:shadow-outline">
                        <option value= null disabled hidden>Seleziona Speaker</option>
                        <option v-for="speaker in speakers" :key="speaker.id" :value="speaker.id">{{ speaker.name + ' ' + speaker.last_name }}</option>
                    </select>
                </div>
                <div class="mr-1 md:mr-0">
                    <select name="category" v-model="category" class="w-full px-2 py-2 bg-white border border-gray-300 lg:w-64 md:w-40 xl:w-80 hover:border-gray-400 focus:outline-none focus:shadow-outline">
                        <option value= null disabled hidden>Seleziona Categoria</option>
                        <option name="category" v-for="category in categories" :key="category.id" :value="category.id">{{ category.name }}</option>
                    </select>
                </div>
                <div class="mr-1 md:mr-0">
                    <select name="region" v-model="region" class="w-full px-2 py-2 bg-white border border-gray-30 lg:w-64 md:w-40 xl:w-80 hover:border-gray-400 focus:outline-none focus:shadow-outline">
                        <option value= null disabled hidden>Seleziona Regione</option>
                        <option name="region" v-for="region in regions" :key="region.id" :value="region.id">{{ region.name }}</option>
                    </select>
                </div>
                <div>
                    <button name="submit" value="submit" type="submit" class="px-2 py-2 mr-1 font-semibold text-white bg-pink-500 rounded cursor-pointer md:mr-0 sm:px-10 hover:shadow-custom">Cerca</button>
                </div>
                <div>
                    <button name="submit" value="reset" type="submit" class="px-2 pt-1.5 pb-0.5 font-semibold text-white bg-pink-500 rounded cursor-pointer hover:shadow-custom"><i class="pt-0.5 material-icons">refresh</i></button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
    export default {
        props:[
            'regions',
            'speakers',
            'categories',
        ],
        data() {
            return {
                region: null,
                speaker: null,
                category: null,
                csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
            };
        },
    }
</script>


